import { Routes } from "@angular/router";
import { environment } from '../environments/environment';

export const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
        data: { title: environment.pageTitle.default }
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
        data: { title: environment.pageTitle.adminPanel }
    },
    {
        path: 'agent',
        loadChildren: () => import('./agent/agent.module').then(m => m.AgentModule),
        data: { title: environment.pageTitle.agentPanel }
    },
    {
        path: 'upload',
        loadChildren: () => import('./file-upload/file-upload.module').then(m => m.FileUploadModule),
        data: { title: environment.pageTitle.default }
    },
    {
        path: 'signup',
        loadChildren: () => import('./signup/signup.module').then(m => m.SignupModule),
        data: { title: environment.pageTitle.default }
    },
    {
        path: '',
        loadChildren: () => import('./client/client.module').then(m => m.ClientModule),
        data: { title: environment.pageTitle.clientViews }
    },
    // {
    //     path: '**',
    //     // component: PageNotFoundComponent 
    //     redirectTo: 'auth', //TODO: to powinno być przekierowanie do PageNotFoundComponent
    // }
];